import { useContext, useEffect } from 'react'

import { QuizContext } from '@f/applications/QuizApp/context/QuizContext'
import { QuizStep } from '@f/applications/QuizApp/partials/types'
import { roundToTenThousand } from '@f/applications/QuizApp/questions/QuestionBudget/utils'
import QuestionSlider from '@f/applications/QuizApp/questions/QuestionSlider'

const real_estate_transfer_tax = 0.06
const brokerage_fee = 0.0357
const notary_fee = 0.02
const min_equity_to_expected_value_ratio = 0.2

export const QuestionEquitySlider = ({ step }) => {
  const context = useContext(QuizContext)

  const loanPurpose = context.data.steps.find(
    (s: QuizStep) => s.id === 'loan_purpose'
  )?.values?.[0]?.value
  const loanPurposeIsBuilding =
    loanPurpose === 'building_project' || loanPurpose === undefined
  const expectedValueStep = context.data.steps.find(
    ({ id }: { id: string }) => id === 'expected_value'
  )?.values
  const building_costs = expectedValueStep?.find(
    ({ name }) => name === 'building_costs'
  )?.value
  const property_costs = expectedValueStep?.find(
    ({ name }) => name === 'property_costs'
  )?.value
  const purchase_price = expectedValueStep?.find(
    ({ name }) => name === 'purchase_price'
  )?.value
  const modernization_costs = expectedValueStep?.find(
    ({ name }) => name === 'modernization_costs'
  )?.value
  const loan_amount = context.data.steps.find(
    ({ id }: { id: string }) => id === 'loan_amount_slider'
  )?.values[0]?.value

  const expectedValue = loanPurposeIsBuilding
    ? building_costs + property_costs
    : purchase_price + modernization_costs
  const totalFees = real_estate_transfer_tax + brokerage_fee + notary_fee

  const additionalCosts = loanPurposeIsBuilding
    ? property_costs * totalFees
    : purchase_price * totalFees

  useEffect(() => {
    if (step.values[0].value === step.sliders[0].defaultValue) {
      context.actions.updateValues({
        stepID: step.id,
        valuesToSave: [
          {
            name: 'equity',
            value: roundToTenThousand(
              (expectedValue + additionalCosts) *
                min_equity_to_expected_value_ratio
            )
          }
        ]
      })
    }
  }, [])

  const alteredStep = {
    ...step,
    sliders: [
      {
        ...step.sliders[0],
        minValue: roundToTenThousand(additionalCosts),
        maxValue: roundToTenThousand(
          expectedValue + additionalCosts - loan_amount
        )
      }
    ]
  }

  return <QuestionSlider step={alteredStep} />
}
